import { render, staticRenderFns } from "./AnnouncementIndex.vue?vue&type=template&id=fb235f06"
import script from "./AnnouncementIndex.js?vue&type=script&lang=js&external"
export * from "./AnnouncementIndex.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports